import React, { ReactElement, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import * as adminApi from 'js/utils/adminApi';
import { ISelfUser } from 'store/slices/types';

interface Props {
    children: ReactElement;
}

export default function AdminRoute({ children }: Props): ReactElement {
    const [user, setUser] = useState<ISelfUser | null>(null);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        let cancelled = false;
        adminApi
            .getMe()
            .then(me => {
                if (!cancelled) setUser(me);
            })
            .catch(() => {
                if (!cancelled) setUser(null);
            })
            .finally(() => {
                if (!cancelled) setChecked(true);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    if (!localStorage.token) {
        return <Navigate to="/login" replace />;
    }

    if (!checked) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: 48,
                }}
            >
                <Spin size="large" />
            </div>
        );
    }

    if (!user || !user.is_superuser) {
        return <Navigate to="/" replace />;
    }

    return children;
}
